var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBronze(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 69"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1",
    d: "M26.5601 14.5192C26.5601 21.2275 20.9564 26.7305 13.9628 26.7305C6.96912 26.7305 1.36544 21.2275 1.36544 14.5192C1.36544 7.81091 6.96912 2.30789 13.9628 2.30789C20.9564 2.30789 26.5601 7.81091 26.5601 14.5192Z",
    fill: "#FFB56D",
    stroke: "#4E5866",
    strokeWidth: 2.73089
  }), /*#__PURE__*/React.createElement("path", {
    id: "Star 1",
    d: "M14.2215 6.11357L15.9541 11.2986L16.11 11.765H16.6016H22.1544L17.6787 14.9268L17.2643 15.2196L17.4251 15.7008L19.1449 20.8474L14.6154 17.6475L14.2215 17.3692L13.8276 17.6475L9.29807 20.8474L11.0178 15.7008L11.1786 15.2196L10.7642 14.9268L6.28862 11.765H11.8413H12.333L12.4889 11.2986L14.2215 6.11357Z",
    fill: "white",
    stroke: "#4E5866",
    strokeWidth: 1.36544
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBronze);
export default __webpack_public_path__ + "static/media/bronze.aa384d0a97ba6628b89f33d881200fef.svg";
export { ForwardRef as ReactComponent };